/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

/**
 * Centralized reCAPTCHA action strings.
 * Single source of truth for actions used with recaptchaManager.execute().
 * Enables autocompletion and compile-time typo detection.
 */
export const RECAPTCHA_ACTIONS = {
  LOGIN: 'login',
  LOGIN_MOBILE_PHONE_OTP: 'login/mobilePhoneOtp',
  LOGIN_2FA_BY_CREDENTIALS: 'login2fa/byCredentials',
  REGISTRATION: 'registration',
  SIGNUP: 'signup',
  DELETE: 'delete',
  USER_MOBILE_OTP: 'userMobileOtp',
  /** Returns action for 2FA method, e.g. login2fa/method/email */
  LOGIN_2FA_METHOD: (method: string) =>
    `login2fa/method/${method.toLowerCase()}`,
} as const;
